/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 4/11/2023
 */



let checkByIdOrInstance = (l, r) => l && r && l.id && l.id === r.id || l == r

Array.prototype.pushUnique = function(element, equalsPredicate = checkByIdOrInstance) {
	let index = this.findIndex(item => equalsPredicate(item, element))
	if(index < 0){
		this.push(element)
		return true
	} else {
		this[index] = element
	}
	return false
}

Array.prototype.unshiftUnique = function(element, equalsPredicate = checkByIdOrInstance) {
	let index = this.findIndex(item => equalsPredicate(item, element))
	if(index < 0){
		this.unshift(element)
		return true
	} else {
		this[index] = element
	}
	return false
}



Object.defineProperty(Array.prototype, 'deleteItem', {
	value: function(element, equalsPredicate = checkByIdOrInstance) {
		if (typeof element === 'function') {
			equalsPredicate = element;
			element = undefined;
		}
		const index = this.findIndex(item => equalsPredicate(item, element));
		if (index >= 0) {
			this.splice(index, 1);
			return true;
		}
		return false;
	},
	enumerable: false
});
Array.prototype.removeAllElements = function() {
	while (this.length) {
		this.pop();
	}
}

Array.prototype.diffLeft = function(arr, predicate = (l, r) => l.id && r.id ? l.id === r.id : l === r) {
	return this.filter(x => !arr.some(y => predicate(x, y)));
}

Array.prototype.qwIncludesAny = function(arr, predicate = (l, r) => l.id && r.id ? l.id === r.id : l === r) {
	return this.some(r=> arr.some(l => predicate(l, r)))
}




Object.defineProperty(String.prototype, 'qwCapitalize', {
	value: function() {
		return this.charAt(0).toUpperCase() + this.slice(1);
	},
	enumerable: false
});

Object.defineProperty(String.prototype, 'qwIncludesAny', {
	value: function(arr) {
		if (!Array.isArray(arr)) return false;
		return arr.some(str => this.includes(str));
	},
	enumerable: false
});
